// extracted by mini-css-extract-plugin
export default {"container":"Chip_container__1Z-FH","content":"Chip_content__31zxN"};